import React from 'react';
import { Collapse } from 'antd';
import { CollapseProps } from 'antd/lib';
import WorkingTime from '../WorkingTime';
import { safeJSONParse } from 'utils/generalHelpers';
import { FarmInfrastructures, OpenHours } from 'types/FarmData';
import { FarmInfrastructuresWrapper } from './style';

interface InfrastructureProps {
  daysOfWeek: string[]
  infrastructures: FarmInfrastructures[] | undefined
}

const Infrastructures: React.FC<InfrastructureProps> = ({
  daysOfWeek,
  infrastructures = [],
}) => {
  const items: CollapseProps['items'] = infrastructures.map((infrastructure) => ({
    key: infrastructure.id,
    label: infrastructure.object_name,
    children: (
      <WorkingTime
        workingTime={safeJSONParse<OpenHours[]>(infrastructure.open_hours, [])}
        daysOfWeek={daysOfWeek}
      />
    ),
  }));

  return (
    <FarmInfrastructuresWrapper className="farm-partner">
      <Collapse
        expandIconPosition="end"
        className="custom-collapse"
        items={items}
      />
    </FarmInfrastructuresWrapper>
  )
}

export default Infrastructures;
